import {
  IPrebookOfferResponse200,
  TPrebookOfferResponse,
} from '../../../repositories/profitbase-booking/v1/prebook-offer';
import { ResponseError } from '../../../utils/errors';

export function assertResponseStatus(response: TPrebookOfferResponse): asserts response is IPrebookOfferResponse200 {
  if (response.statusCode !== 200) {
    const { errors, message } = response.response;

    throw new ResponseError({
      domain: 'NewbuildingCard.services.fetchProfitbaseBooking',
      message,
      details: { errors },
    });
  }
}
